// src/api/endpoints/basket.js

import { rootApi } from "../rootApi";

export const basketApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // 1) Sepeti getir
    getBasket: builder.query({
      query: () => ({
        url: "v1/basket/get-basket",
        method: "GET"
      }),
      providesTags: ["Basket"]
    }),

    // 2) Sepete ürün ekle/güncelle
    addOrUpdateBasket: builder.mutation({
      query: (payload) => ({
        url: "v1/basket/add-or-update-basket",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json"
        }
      }),
      invalidatesTags: ["Basket"]
    }),

    // 3) Ürünü sepetten sil
    removeFromBasket: builder.mutation({
      query: (itemCode) => ({
        url: "v1/basket/remove-product",
        method: "DELETE",
        body: { itemCode }
      }),
      invalidatesTags: ["Basket"]
    }),

    // 4) Sepeti boşalt
    clearBasket: builder.mutation({
      query: () => ({
        url: "v1/basket/remove-basket",
        method: "POST"
      }),
      invalidatesTags: ["Basket"]
    }),

    // 5) Adet güncelleme
    updateProductQuantityInBasket: builder.mutation({
      query: (payload) => ({
        url: "v1/basket/update-product-quantity",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json"
        }
      }),
      invalidatesTags: ["Basket"]
    }),

    // Prefill
    getConvertPrefill: builder.query({
      query: ({ languageId } = {}) => ({
        url: `v1/basket/convert-prefill${languageId ? `?languageId=${languageId}` : ""}`,
        method: "GET"
      })
    }),

    // Convert to Order
    convertBasketToOrder: builder.mutation({
      query: (payload) => ({
        url: "v1/basket/convert-to-order",
        method: "POST",
        body: payload,
        headers: { "Content-Type": "application/json" }
      }),
      invalidatesTags: ["Basket"]
    }),
    importBasket: builder.mutation({
      query: (file) => {
        const form = new FormData();
        form.append("File", file); // C#'taki property adıyla aynı
        return {
          url: "v1/basket/import",
          method: "POST",
          body: form,
        };
      },
      invalidatesTags: ["Basket"]
    }),

    // Servis Bültenleri getir
    getServiceBulletins: builder.query({
      query: () => ({
        url: "v1/basket/get-service-bulletins",
        method: "GET"
      })
    }),

    // Servis bültene göre şasileri getir
    getChassisByBulletin: builder.query({
      query: (qmnum) => ({
        url: `v1/basket/get-chassis-by-bulletin?qmnum=${qmnum}`,
        method: "GET"
      })
    }),

    // Servis bülten siparişini sepete ekle
    addServiceBulletinToBasket: builder.mutation({
      query: (payload) => ({
        url: "v1/basket/add-service-bulletin-to-basket",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json"
        }
      }),
      invalidatesTags: ["Basket"]
    }),

    // Teslimat tarihi güncelleme
    updateDeliveryDate: builder.mutation({
      query: (payload) => ({
        url: "v1/basket/update-delivery-date",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json"
        }
      }),
      invalidatesTags: ["Basket"]
    }),

    getBasketPdfData: builder.query({
      query: () => ({
        url: "v1.0/Basket/pdf-data",
        method: "GET"
      }),
      transformResponse: (response) => response.data
    })
  })
});

export const {
  useGetBasketQuery,
  useAddOrUpdateBasketMutation,
  useRemoveFromBasketMutation,
  useClearBasketMutation,
  useUpdateProductQuantityInBasketMutation,
  useGetConvertPrefillQuery,
  useLazyGetConvertPrefillQuery,
  useConvertBasketToOrderMutation,
  useImportBasketMutation,
  useGetServiceBulletinsQuery,
  useLazyGetChassisByBulletinQuery,
  useAddServiceBulletinToBasketMutation,
  useUpdateDeliveryDateMutation,
  useLazyGetBasketPdfDataQuery
} = basketApi;
